import * as Yup from "yup";
import moment from "moment";

export const workshopVoiceSchema = Yup.object().shape({
  trainer: Yup.number()
    .required("Please select Instuctor/Coach")
    .min(1, "Please select Instuctor/Coach"),
  capacity: Yup.number()
    .positive("Capacity must be greater than 0")
    .required("Capacity is required"),
  waitingList: Yup.boolean(),
  repeatDays: Yup.array()
    .min(1, "Select at least one day")
    .required("Please select days of class"),
  endDate: Yup.date().required("Class end date is required"),
  startDate: Yup.date().required("Class start date is required"),
  timesArray: Yup.array()
    .min(1, "Select at least one time range")
    .of(
      Yup.object().shape({
        from: Yup.string()
          .required("Please select start time")
          .test("is-before-end", "Start time must be before end time", function(value) {
            const { to } = this.parent;
            return moment(value, "HH:mm").isBefore(moment(to, "HH:mm"));
          }),
        to: Yup.string()
          .required("Please select end time")
          .test("is-after-start", "End time must be after start time", function(value) {
            const { from } = this.parent;
            return moment(value, "HH:mm").isAfter(moment(from, "HH:mm"));
          }),
      })
    )
    .test(
      "is-time-range-conflict",
      "Time ranges should not overlap",
      function(value) {
        if (!value) return true;
        const timeRanges = value.map((range) => ({
          from: moment(range.from, "HH:mm"),
          to: moment(range.to, "HH:mm"),
        }));
        for (let i = 0; i < timeRanges.length; i++) {
          for (let j = i + 1; j < timeRanges.length; j++) {
            if (
              timeRanges[i].from.isBetween(
                timeRanges[j].from,
                timeRanges[j].to,
                null,
                "[)"
              ) ||
              timeRanges[i].to.isBetween(
                timeRanges[j].from,
                timeRanges[j].to,
                null,
                "(]"
              )
            ) {
              return false;
            }
          }
        }
        return true;
      }
    ),
  name: Yup.string()
    .max(300, "cannot be > 300 characters")
    .required("Class name is required"),
  type: Yup.string().required("Please select class type"),
  groupType: Yup.string().required("Please select type"),
  freeTrial: Yup.boolean(),
  autoCreateSinglePackage: Yup.boolean(),
  image: Yup.string(),
  cancelBefore: Yup.string().required("Cancelation time is required"),
  waitingListRule: Yup.string().when("waitingList", {
    is: true,
    then: Yup.string().required("Wait list capacity is required"),
  }),
  waitingListCapacity: Yup.number().when("waitingList", {
    is: true,
    then: Yup.number()
      .positive("Capacity must be > 0")
      .required("Wait list capacity is required"),
  }),
  packageName: Yup.string().required("Package Name is required"),
  packagePrice: Yup.number()
    .required("Package Price is required")
    .min(0, "Price cant less than 0"),
  numberOfSessions: Yup.number().required(
    "Package number of  sessions is required"
  ),
  packageDuration: Yup.number().required("Package Duration is required"),
});
